import * as React from 'react';
import './loader.css';

const MarsLoader = () => (
  <div id="loader">
    <div id="earth"></div>
  </div>
);

export default MarsLoader;